import React, { useState } from 'react';
import './Exhead.css';

const ExHeadOfCentre = () => {
  const [selectedHead, setSelectedHead] = useState(null);

// const formerHeads = [
//   { period: "....", name: "Prof. M. K. Jain", tenure: "N/A" },
//   { period: "Sep 1988 – Aug 1992", name: "Prof. R. K. Arora", tenure: "4 years" },
//   { period: "Sep 1992 – Aug 1995", name: "Prof. B. B. Madaan", tenure: "3 years" },
//   { period: "Sep 1995 – Aug 1996", name: "Prof. R. K. Arora", tenure: "1 year" },
//   { period: "Sep 1996 – Aug 1999", name: "Prof. C. V. Rama Krishnan", tenure: "3 years" },
//   { period: "Sep 1999 – Aug 2002", name: "Prof. S. K. Koul", tenure: "3 years" },
//   { period: "Sep 2002 – Aug 2003", name: "Prof. Chandra Shakher", tenure: "1 year" },
//   { period: "Sep 2003 – Aug 2006", name: "Prof. B. P. Pal", tenure: "3 years" },
//   { period: "Sep 2006 – Aug 2009", name: "Prof. A. K. Gosain", tenure: "3 years" },
//   { period: "Sep 2009 – Aug 2012", name: "Prof. Subhasish Banerjee", tenure: "3 years" },
//   { period: "Sep 2012 – Aug 2015", name: "Prof. Arun Kumar", tenure: "3 years" },
//   { period: "Sep 2015 – Aug 2018", name: "Prof. Huzur Saran", tenure: "3 years" },
//   { period: "Sep 2018 – Aug 2020", name: "Prof. Prem Kumar Kalra", tenure: "2 years" },
//   { period: "Sep 2020 – Aug 2023", name: "Mr. K. Narayanan", tenure: "3 years" },
//   { period: "Sep 2023 – Aug 2025", name: "Mr. Pardeep Kumar Gupta", tenure: "2 years" }
// ];

const formerHeads = [
  { period: "Sep 2023 – Aug 2025", name: "Mr. Pardeep Kumar Gupta", tenure: "2 years" },
  { period: "Sep 2020 – Aug 2023", name: "Mr. K. Narayanan", tenure: "3 years" },
  { period: "Sep 2018 – Aug 2020", name: "Prof. Prem Kumar Kalra", tenure: "2 years" },
  { period: "Sep 2015 – Aug 2018", name: "Prof. Huzur Saran", tenure: "3 years" },
  { period: "Sep 2012 – Aug 2015", name: "Prof. Arun Kumar", tenure: "3 years" },
  { period: "Sep 2009 – Aug 2012", name: "Prof. Subhasish Banerjee", tenure: "3 years" },
  { period: "Sep 2006 – Aug 2009", name: "Prof. A. K. Gosain", tenure: "3 years" },
  { period: "Sep 2003 – Aug 2006", name: "Prof. B. P. Pal", tenure: "3 years" },
  { period: "Sep 2002 – Aug 2003", name: "Prof. Chandra Shakher", tenure: "1 year" },
  { period: "Sep 1999 – Aug 2002", name: "Prof. S. K. Koul", tenure: "3 years" },
  { period: "Sep 1996 – Aug 1999", name: "Prof. C. V. Rama Krishnan", tenure: "3 years" },
  { period: "Sep 1995 – Aug 1996", name: "Prof. R. K. Arora", tenure: "1 year" },
  { period: "Sep 1992 – Aug 1995", name: "Prof. B. B. Madaan", tenure: "3 years" },
  { period: "Sep 1988 – Aug 1992", name: "Prof. R. K. Arora", tenure: "4 years" },
  { period: "....", name: "Prof. M. K. Jain", tenure: "N/A" }
];


  const handleCardClick = (index) => {
    setSelectedHead(selectedHead === index ? null : index);
  };

  return (
    <div className="heads-showcase">
      {/* Header Section */}
      <div className="showcase-header">
        <div className="header-decoration">
          <div className="decoration-line"></div>
          <div className="decoration-diamond"></div>
          <div className="decoration-line"></div>
        </div>
        <h1 className="showcase-title">
          <span className="title-former">Former</span>
          <span className="title-heads">Heads of CSC</span>
        </h1>
        {/* <p className="showcase-subtitle">
          Celebrating the legacy of leadership and excellence
        </p> */}
        <div className="header-decoration">
          <div className="decoration-line"></div>
          <div className="decoration-diamond"></div>
          <div className="decoration-line"></div>
        </div>
      </div>


      {/* Heads Grid */}
      <div className="heads-grid">
        {formerHeads.map((head, index) => (
          <div 
            key={index} 
            className={`head-card ${selectedHead === index ? 'selected' : ''}`}
            onClick={() => handleCardClick(index)}
          >
            {/* <div className="card-header">
              <div className="card-number">{String(index + 1).padStart(2, '0')}</div>
              <div className="card-icon">
                <div className="icon-circle">
                  <div className="icon-inner"></div>
                </div>
              </div>
            </div>
             */}
            <div className="card-content">
              <div className="card-period">{head.period}</div>
              <div className="card-name">{head.name}</div>
              <div className="card-tenure">Tenure: {head.tenure}</div>
            </div>

            <div className="card-footer">
              <div className="card-accent"></div>
            </div>

            {/* Hover Effect Elements */}
            <div className="card-glow"></div>
            <div className="card-shine"></div>
          </div>
        ))}
      </div>


      {/* Footer */}
      {/* <div className="showcase-footer">
        <div className="footer-text">
          A tribute to the visionaries who shaped our center's journey
        </div>
      </div> */}
    </div>
  );
};

export default ExHeadOfCentre;